<template>
  <el-dialog :visible.sync="open_modal" title="订单日志" width="50%" class="order_box">
    <div class="divBox">
      <el-table :data="list">
        <el-table-column prop="opUserType" label="操作人类型"></el-table-column>
        <el-table-column prop="operationUserName" label="操作人姓名"></el-table-column>
        <el-table-column prop="operationTimeStr" label="操作时间"></el-table-column>
        <el-table-column prop="operationType" label="操作类型"></el-table-column>
        <el-table-column prop="logContent" label="操作内容"></el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
          background
          :page-size="thisForm.limit"
          :current-page="thisForm.page"
          :total="total"
          :page-sizes="[20, 40, 60, 80]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="pageChange"
        />
      </div>
    </div>
    <span slot="footer">
    </span>
  </el-dialog>
</template>

<script>
import {getOrderLog} from '@/api/order'

export default {
  name: "orderLog",
  data() {
    return {
      open_modal: false,
      loading: false,
      thisForm: {
        page: 1,
        limit: 20,
        objId: 0
      },
      list: [],
      total: 0,
    };
  },
  create() {
    this.getList();
  },
  methods: {
    // 分页
    pageChange(index) {
      this.thisForm.page = index;
      this.getList();
    },
    handleSizeChange(val) {
      this.thisForm.limit = val;
      this.getList();
    },
    // 列表
    getList() {
      this.loading = true;
      getOrderLog(this.thisForm).then((data) => {
        this.loading = false;
        this.list = data.list;
        this.total = data.total;
      }).catch((err) => {
        this.loading = false;
        this.$message.error(err.msg);
      })
    },
    // 重置
    reset() {
      this.$emit("submitOk");
    },
  },
};
</script>

<style>
.ivu-description-list-title {
  margin-bottom: 30px;
  color: #17233d;
  font-weight: bold;
  font-size: 14px;
}

.ivu-table th {
  background-color: #f8f8f9 !important;
}
</style>
